import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuard} from '../../auth.guard';
import { AddUserComponent } from './add-user/add-user.component';
import { ManageUserComponent } from './manage-user/manage-user.component';
import { ManageCompanyAccountsComponent } from './manage-company-accounts/manage-company-accounts-list.component';
import { AssignUserListComponent } from './assign-user/assign-user-list.component';
import { ManageCentreComponent } from './manage-centre/manage-centre-list.component';

import { ManagePatientUserComponent } from './manage-patient-user/manage-patient-list.component';
import { ManagePriceComponent } from './manage-price/manage-price-list.component';
import { NewsMemoComponent } from './news-memo/news-memo.component';
import { ManageVaccineComponent } from './manage-vaccine/manage-vaccine.component';
import { PatientInformationComponent } from './manage-patient-user/patient-information.component';
import { ManageMemoComponent } from './manage-memo/manage-memo.component';
const centreRoutes: Routes = [
    {
        path: '',
        canActivateChild: [AuthGuard],
        children: [
            { path: 'register-user', component: AddUserComponent},
        { path: 'manage-user', component: ManageUserComponent},
            { path: 'assign-user', component: AssignUserListComponent },
            { path: 'manage-centre', component: ManageCentreComponent},
            { path: 'manage-company-accounts', component: ManageCompanyAccountsComponent },
            { path: 'manage-patient', component: ManagePatientUserComponent },
            { path: 'manage-price', component: ManagePriceComponent },
            { path: 'news', component: NewsMemoComponent },
            { path: 'manage-memo', component: ManageMemoComponent },
            { path: 'manage-vaccine', component: ManageVaccineComponent},
            { path: 'patient-information/:id', component: PatientInformationComponent}
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(centreRoutes)],
    exports: [RouterModule],
    providers: []
})
export class CentreRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/centre.routing.ts